import { render, staticRenderFns } from "./admin-color-manager.vue?vue&type=template&id=4f7a220e"
import script from "./admin-color-manager.vue?vue&type=script&lang=js"
export * from "./admin-color-manager.vue?vue&type=script&lang=js"
import style0 from "./admin-color-manager.vue?vue&type=style&index=0&id=4f7a220e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports